<div class="members-wrapper" #mainMembersWrapper>
  @for (formGroup of membersArray; track formGroup; let formGroupIndex = $index) {
    <div class="member-row-wrapper">
      <div
        [id]="'formGroupWrapper-' + formGroupIndex"
        class="member-row"
        role="group"
        [formGroup]="formGroup"
        [attr.aria-labelledby]="'familyMemberGroupLabel-' + formGroupIndex">
        <span class="sr-only" [id]="'familyMemberGroupLabel-' + formGroupIndex">
          {{ 'FAMILY_MEMBERS_FORM.MEMBER' | translate }} {{ formGroupIndex + 1 }}
        </span>
        @if (formGroup.controls.name; as name) {
          <div class="standard-form-field member-name-field required-field">
            <label [for]="'familyMemberName' + formGroupIndex + 'Input'" [class.invalid]="name.touched && name.invalid">
              {{ 'PERSONAL_DATA_FORM.NAME.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                [id]="'familyMemberName' + formGroupIndex + 'Input'"
                matInput
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  name.touched && name.invalid
                    ? 'familyMemberName' + formGroupIndex + 'Error familyMemberName' + formGroupIndex + 'Tooltip'
                    : 'familyMemberName' + formGroupIndex + 'Tooltip'
                "
                [attr.aria-invalid]="name.touched && name.invalid ? 'true' : null"
                placeholder="{{ 'PERSONAL_DATA_FORM.NAME.PLACEHOLDER' | translate }}"
                formControlName="name" />
              <!-- TOOLTIP -->
              <app-cr-form-field-tooltip
                [id]="'familyMemberName' + formGroupIndex + 'Tooltip'"
                class="info-suffix-icon"
                matSuffix
                [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
              </app-cr-form-field-tooltip>
              <!-- ERROR -->
              @if (name.touched && name.invalid) {
                <mat-error [id]="'familyMemberName' + formGroupIndex + 'Error'">
                  {{ name.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (formGroup.controls.surname; as surname) {
          <div class="standard-form-field member-surname-field required-field">
            <label
              [for]="'familyMemberSurname' + formGroupIndex + 'Input'"
              [class.invalid]="surname.touched && surname.invalid">
              {{ 'PERSONAL_DATA_FORM.SURNAME.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                [id]="'familyMemberSurname' + formGroupIndex + 'Input'"
                matInput
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  surname.touched && surname.invalid
                    ? 'familyMemberSurname' + formGroupIndex + 'Error familyMemberSurname' + formGroupIndex + 'Tooltip'
                    : 'familyMemberSurname' + formGroupIndex + 'Tooltip'
                "
                [attr.aria-invalid]="surname.touched && surname.invalid ? 'true' : null"
                placeholder="{{ 'PERSONAL_DATA_FORM.SURNAME.PLACEHOLDER' | translate }}"
                formControlName="surname" />
              <!-- TOOLTIP -->
              <app-cr-form-field-tooltip
                [id]="'familyMemberSurname' + formGroupIndex + 'Tooltip'"
                class="info-suffix-icon"
                matSuffix
                [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
              </app-cr-form-field-tooltip>
              <!-- ERROR -->
              @if (surname.touched && surname.invalid) {
                <mat-error [id]="'familyMemberSurname' + formGroupIndex + 'Error'">
                  {{ surname.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (formGroup.controls.sex; as sex) {
          <div class="standard-form-field member-sex-field required-field">
            <label [for]="'familyMemberSex' + formGroupIndex + 'Input'" [class.invalid]="sex.touched && sex.invalid">
              {{ 'PERSONAL_DATA_FORM.SEX.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                [id]="'familyMemberSex' + formGroupIndex + 'Input'"
                panelClass="standard-select"
                placeholder="{{ 'PERSONAL_DATA_FORM.SEX.PLACEHOLDER' | translate }}"
                formControlName="sex"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  sex.touched && sex.invalid ? 'familyMemberSex' + formGroupIndex + 'Error' : null
                "
                [attr.aria-invalid]="sex.touched && sex.invalid ? 'true' : null">
                @for (item of selectsValues.SEX; track item) {
                  <mat-option [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                }
              </mat-select>
              <!-- ERROR -->
              @if (sex.invalid && sex.touched) {
                <mat-error [id]="'familyMemberSex' + formGroupIndex + 'Error'">
                  {{ sex.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (formGroup.controls.dateOfBirth; as dateOfBirth) {
          <div class="standard-form-field member-dob-field required-field">
            <label
              [for]="'familyMemberDoB' + formGroupIndex + 'Input'"
              [class.invalid]="dateOfBirth.touched && dateOfBirth.invalid">
              {{ 'PERSONAL_DATA_FORM.DATE-OF-BIRTH.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline" (click)="dobPicker.open()">
              <input
                matInput
                [id]="'familyMemberDoB' + formGroupIndex + 'Input'"
                [matDatepicker]="dobPicker"
                (focus)="dobPicker.open()"
                placeholder="{{ 'PERSONAL_DATA_FORM.DATE-OF-BIRTH.PLACEHOLDER' | translate }}"
                (click)="$event.preventDefault()"
                [min]="minValidDate"
                [max]="maxValidDate"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  dateOfBirth.touched && dateOfBirth.invalid ? 'familyMemberDoB' + formGroupIndex + 'Error' : null
                "
                [attr.aria-invalid]="dateOfBirth.touched && dateOfBirth.invalid ? 'true' : null"
                readonly
                formControlName="dateOfBirth" />
              <mat-datepicker-toggle
                matSuffix
                [for]="dobPicker"
                aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
              </mat-datepicker-toggle>
              <mat-datepicker #dobPicker [startView]="'month'" [startAt]="dateOfBirth.value || '2000'">
              </mat-datepicker>
              <!-- ERROR -->
              @if (dateOfBirth.touched && dateOfBirth.invalid) {
                <mat-error [id]="'familyMemberDoB' + formGroupIndex + 'Error'">
                  {{ dateOfBirth.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (formGroup.controls.kinshipDegree; as kinshipDegree) {
          <div class="standard-form-field kinship-field required-field">
            <label
              [for]="'familyMemberKinshipDegree' + formGroupIndex + 'Input'"
              [class.invalid]="kinshipDegree.touched && kinshipDegree.invalid">
              {{ 'PERSONAL_DATA_FORM.KINSHIP-DEGREE.MAIN-LABEL' | translate }} *
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                [id]="'familyMemberKinshipDegree' + formGroupIndex + 'Input'"
                formControlName="kinshipDegree"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  kinshipDegree.touched && kinshipDegree.invalid
                    ? 'familyMemberKinshipDegree' + formGroupIndex + 'Error'
                    : null
                "
                [attr.aria-invalid]="kinshipDegree.touched && kinshipDegree.invalid ? 'true' : null"
                panelClass="standard-select"
                placeholder="{{ 'PERSONAL_DATA_FORM.KINSHIP-DEGREE.PLACEHOLDER' | translate }}">
                @for (item of selectsValues.KINSHIP; track item) {
                  <mat-option [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                }
              </mat-select>
              <!-- ERROR -->
              @if (kinshipDegree.invalid && kinshipDegree.touched) {
                <mat-error [id]="'familyMemberKinshipDegree' + formGroupIndex + 'Error'">
                  {{ kinshipDegree.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        <div class="standard-form-field citizenship-field required-field">
          <app-country-select
            class="country-select"
            [fieldControl]="getControl('citizenship', formGroupIndex)"
            [fieldKey]="'fm-member-' + formGroupIndex + '-citizenship'"
            [isRequired]="true"
            [fieldLabelKey]="'CITIZENSHIP'">
          </app-country-select>
        </div>
        @if (formGroup.controls.residencePlace; as residencePlace) {
          <div class="standard-form-field residence-field required-field">
            <label
              [for]="'familyMemberResidencePlace' + formGroupIndex + 'Input'"
              [class.invalid]="residencePlace.touched && residencePlace.invalid">
              {{ 'PERSONAL_DATA_FORM.PLACE-OF-RESIDENCE.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                [id]="'familyMemberResidencePlace' + formGroupIndex + 'Input'"
                matInput
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-describedby]="
                  residencePlace.touched && residencePlace.invalid
                    ? 'familyMemberResidencePlace' + formGroupIndex + 'Error'
                    : null
                "
                [attr.aria-invalid]="residencePlace.touched && residencePlace.invalid ? 'true' : null"
                placeholder="{{ 'PERSONAL_DATA_FORM.PLACE-OF-RESIDENCE.PLACEHOLDER' | translate }}"
                formControlName="residencePlace" />
              <!-- TOOLTIP -->
              <app-cr-form-field-tooltip
                matSuffix
                class="info-suffix-icon"
                [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
              </app-cr-form-field-tooltip>
              <!-- ERROR -->
              @if (residencePlace.touched && residencePlace.invalid) {
                <mat-error [id]="'familyMemberResidencePlace' + formGroupIndex + 'Error'">
                  {{ residencePlace.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      @if (groupStatus[formGroupIndex]; as groupStatus) {
        <div class="action-buttons">
          <!-- Show add member button only under last member -->
          @if (formGroupIndex === membersArray.length - 1) {
            <button
              [disabled]="groupStatus.showLoading"
              (click)="addNewMember()"
              (keydown.Tab)="lastFieldTabPressed.emit($event)"
              class="standard-form-button add-member-button">
              {{ 'FAMILY_MEMBERS_FORM.ADD_NEW_MEMBER' | translate }}
            </button>
          }
          <div
            class="remove-member-button-container"
            matTooltip="{{ 'PERSONAL_DATA_FORM.CANNOT_REMOVE_LAST_MEMBER' | translate }}"
            matTooltipClass="personalDataFormTooltip"
            [matTooltipDisabled]="membersArray.length > 1">
            <button
              mat-icon-button
              [disabled]="membersArray.length === 1"
              (click)="showConfirm(formGroupIndex)"
              color="warn"
              [attr.aria-label]="
                membersArray.length === 1
                  ? ('COMMON.LABEL.DELETE_ELEMENT_UNAVAILABLE' | translate)
                  : ('FAMILY_MEMBERS_FORM.REMOVE_MEMBER' | translate)
              ">
              <mat-icon
                [class]="groupStatus.showLoading || membersArray.length === 1 ? 'trash-disabled' : 'trash'"
                svgIcon="trash"></mat-icon>
            </button>
          </div>
          @if (groupStatus.showLoading) {
            <div class="loading-wrapper" role="status" aria-live="polite">
              <span class="sr-only">
                {{ 'COMMON.LAYOUT.LOADING' | translate }}
              </span>
              <mat-spinner
                id="personalDetailsFamilyMemberSavingLoading-{{ formGroupIndex }}"
                [diameter]="35"
                [attr.aria-hidden]="true"></mat-spinner>
            </div>
          }
          @if (groupStatus.showSaved) {
            <div class="notification-wrapper saved-notification saved-fm-{{ formGroupIndex }}" aria-live="polite">
              <mat-icon svgIcon="check-outline"></mat-icon>
              <span class="text">{{ 'FAMILY_MEMBERS_FORM.MEMBER_SAVED_SUCCESSFULLY' | translate }} </span>
            </div>
          }
          @if (!groupStatus.showSaved && !groupStatus.showLoading && !groupStatus.showError) {
            <div class="notification-wrapper awaiting-notification" aria-live="polite">
              <mat-icon svgIcon="info-outline"></mat-icon>
              <span class="text">{{ 'FAMILY_MEMBERS_FORM.AWAITING_FOR_ALL_REQUIRED_DATA' | translate }} </span>
            </div>
          }
          @if (groupStatus.showError) {
            <div class="notification-wrapper error-notification" aria-live="polite">
              <mat-icon fontSet="material-icons-outlined">cancel</mat-icon>
              <span class="text">{{ 'COMMON.ERROR.ERROR_SAVING_FORM' | translate }} </span>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
